import React, { useState } from 'react'
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
import { FiChevronRight, FiLayers } from 'react-icons/fi'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { NotificationBadge } from '../../Menu/Notifications/Components'
import Typography from '../components/Typography'
import { getTaskBadge } from '../../../../../reducers/tasks/selectors'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { getUserId, getUserPriceGroup } from '../../../../../reducers/userAccount/selectors/userAccount'
import { isInPlanScope, PlansScope, useLicensePlansScope } from '../../../Sidebar/Menu'
import { isLicenseValid } from '../../../../../reducers/userAccount/selectors/license'
import { PopoveredIcon2 } from '../../../../../components/PopoveredIcon/PopoveredIcon'
import UpgradePremiumBlockScreenModal from '../../../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'

function TaskMenu() {
  const taskCount = useSelector(getTaskBadge)
  const userId = useSelector(getUserId)
  const { t } = useTranslation()
  const planScope = useLicensePlansScope()
  const licenseValid = useSelector(isLicenseValid)
  const userPriceGroup = useSelector(getUserPriceGroup)
  const isInUserPlan = isInPlanScope(planScope, PlansScope.Tasks,userPriceGroup)
  const [isModalOpened, setIsModalOpened] = useState(false)

  function onClick() {
    if (licenseValid && !isInUserPlan) {
      Mixpanel.people.increment(userId, 'Tasks Menu Opened', 1)
      Mixpanel.track('Tasks Menu Item Used', {
        'Number Of Tasks': Number(taskCount),
      })
      ;(window as any).routerHistory.push('/tasks', {})
    } else {
      setIsModalOpened(true)
    }

  }

  return (
    <>
      <ListItem style={{ minHeight: '60px' }} button={true} onClick={onClick}>
        <ListItemIcon style={{ minWidth: '30px', width: '30px' }}>
          <>
            <FiLayers size={20} style={{ minHeight: 20, minWidth: 20 }} />
            <div style={{ left: '-15px', position: 'relative', top: '-10px' }}>
              <NotificationBadge
                taskCount={taskCount ? String(taskCount) : '0'}
              />
            </div>
          </>
        </ListItemIcon>
        <ListItemText  primary={<Typography>
          {t('menu_todolist')}
          {(!licenseValid || isInUserPlan) && <div style={{marginLeft: '8px', display: 'inline-block'}}><PopoveredIcon2/></div>}
        </Typography>} />
        <FiChevronRight />
      </ListItem>
      <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />
    </>
  )
}

export default TaskMenu
